import { Text } from '@chakra-ui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { NFTCollectionLimitReachedImage } from '../../components/04error/nftCollectionLimitReachedImage';



type Props = {}
export const NFTCollectionLimitReachedPage: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const NFTCollectionLimitReachedPageComponent = styled.main`
    text-align: center;
    background-color: #555555;
    color: white;
    font-family: 'Noto Sans JP',sans-serif;
    font-style: normal;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
  `;
  return (
    <NFTCollectionLimitReachedPageComponent>
        <div>
            <NFTCollectionLimitReachedImage/>
            <Text 
                fontSize="17px" 
                fontWeight="bold" 
                color="rgb(255, 177, 106)" 
                paddingTop="30px"
                whiteSpace={'pre-line'}
            >
              {t(`コレクションの上限に達したため、\nこのNFTを受け取ることはできません。`)}
            </Text>
        </div>
    </NFTCollectionLimitReachedPageComponent>
  );
};